import { Link } from '@vkontakte/vkui';
import React, { HTMLAttributes } from 'react';
import { useDispatch } from 'react-redux';
import { historyPush } from 'reactApp/modules/router/router.module';
import { getIdByStorage } from 'reactApp/modules/storage/storage.helpers';
import { EStorageType } from 'reactApp/modules/storage/storage.types';

import { BaseMessage } from '../BaseMessage/BaseMessage';
import styles from './ErrorSearch.css';
import { ReloadButton } from './ReloadButton/ReloadButton';

interface IProps extends HTMLAttributes<HTMLDivElement> {
    isMobile?: boolean;
}

export const ErrorSearch: React.FC<IProps> = ({ isMobile = false, ...props }) => {
    const dispatch = useDispatch();

    const onClick = () => {
        dispatch(historyPush({ id: getIdByStorage(EStorageType.home), search: '' }));
    };

    return (
        <>
            <BaseMessage
                img={<div className={styles.image} />}
                title="Не удалось выполнить поиск"
                text={
                    <>
                        Попробуйте обновить страницу через несколько минут или <Link onClick={onClick}>сбросьте поиск.</Link>
                    </>
                }
                {...props}
            >
                {!isMobile && <ReloadButton isMobile />}
            </BaseMessage>
            {isMobile && <ReloadButton isMobile />}
        </>
    );
};

ErrorSearch.displayName = 'ErrorSearch';
